var IntervalComponent = /** @class */ (function () {
    function IntervalComponent(fnc, options) {
        this.fnc = fnc;
        this.options = options;
    }
    IntervalComponent.prototype.isEqual = function (node) {
        return this.__proto__ === node.__proto__;
    };
    IntervalComponent.prototype.render = function () {
        return { tag: "input", attr: { type: "hidden" } };
    };
    IntervalComponent.prototype.onInit = function (render) {
        this.renderer = render;
    };
    IntervalComponent.prototype.onCreate = function (node) {
        var _this = this;
        var timeoutRef = node.dom.value;
        if (timeoutRef && timeoutRef !== "0") {
            clearTimeout(parseInt(timeoutRef, 10));
            node.dom.value = "";
        }
        var f = function () {
            var result;
            try {
                result = _this.fnc();
            }
            catch (e) {
                console.error(e);
                if (_this.options.stopOnError) {
                    return;
                }
            }
            var isPromise = result && typeof result.then === "function" && typeof result.catch === "function";
            if (isPromise) {
                result.then(function () {
                    if (!_this.options.noRefresh) {
                        _this.renderer.refresh();
                    }
                    node.dom.value = setTimeout(f, _this.options.interval).toString();
                }).catch(function (e) {
                    console.error(e);
                    if (!_this.options.stopOnError) {
                        if (!_this.options.noRefresh) {
                            _this.renderer.refresh();
                        }
                        node.dom.value = setTimeout(f, _this.options.interval).toString();
                    }
                });
            }
            else {
                if (!_this.options.noRefresh) {
                    _this.renderer.refresh();
                }
                node.dom.value = setTimeout(f, _this.options.interval).toString();
            }
        };
        f();
    };
    IntervalComponent.prototype.onRemove = function (node) {
        var timeoutRef = node.dom.value;
        if (timeoutRef && timeoutRef !== "0") {
            clearTimeout(parseInt(timeoutRef, 10));
            node.dom.value = "";
        }
    };
    return IntervalComponent;
}());
export { IntervalComponent };
